import { NgModule } from '@angular/core';
import { FullWidthComponent } from './containers/full-width/full-width.component';
import { RouterModule } from '@angular/router';
import {
  ConfirmModalModule,
  ErrorContainerModule,
  FileUploadModule, GenericNavigationModule, InputTextModule, RoleGenericTableModule, SchoolSelectorModule,
  TableModule,
  ValidatedInputFieldModule,
  SchoolCalendarCommonsModule,
} from 'ccc-commons/core';
import { NgbAlertModule, NgbDatepickerModule, NgbDropdownModule, NgbPaginationModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderComponent } from './components/header/header.component';
import { LoginAsAlertComponent } from '../components/login-as-alert/login-as-alert.component';
import { OrganizationRowComponent } from './components/organization-row/organization-row.component';
import { OptionsHandlerComponent } from './components/options/options-handler/options-handler.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AddOrganizationBelowComponent } from './components/organization-row/add-organization-below/add-organization-below.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import { StateAbbreviationPipe } from './pipes/state-abbreviation.pipe';
import { XrefListComponent } from './components/xref-list/xref-list.component';
import { LoadingSpinnerComponent } from './components/loading-spinner/loading-spinner.component';
import { ErrorPage } from './components/error-page/error.page';
import { InputNgSearchComponent } from './components/input-ng-search/input-ng-search.component';
import { DistrictRolesComponent } from './components/district-roles/district-roles.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { XrefTableComponent } from './components/xref-list/xref-table/xref-table.component';
import { HorizontalScrollComponent } from './components/horizontal-scroll/horizontal-scroll.component';
import { OnScrollDirective } from './directives/on-scroll.directive';
import { LicensesComponent } from './components/licenses/licenses.component';
import { LicenseModalComponent } from './components/licenses/licenses-modal/licenses-modal.component';
import { LicensesModalImportComponent } from './components/licenses/licenses-modal-import/licenses-modal-import.component';
import { OrganizationFilterComponent } from './components/organization-filter/organization-filter.component';
import { EditOrganizationModalComponent } from './components/edit-organization-modal/edit-organization-modal.component';
import { OptionsStoreService } from './components/options/options-store.service';
import { UserLoggedInComponent } from './components/user-logged-in/user-logged-in.component';
import { UnsubscribeComponent } from './components/base/unsubscribe.component';
import { CccDefaultCalendarComponent } from './components/ccc-default-calendar/ccc-default-calendar.component';
import { RolesContainerComponent } from './components/roles-container/roles-container.component';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [
    FullWidthComponent,
    HeaderComponent,
    LoginAsAlertComponent,
    OrganizationRowComponent,
    OptionsHandlerComponent,
    AddOrganizationBelowComponent,
    TruncatePipe,
    StateAbbreviationPipe,
    XrefListComponent,
    XrefTableComponent,
    LoadingSpinnerComponent,
    ErrorPage,
    InputNgSearchComponent,
    DistrictRolesComponent,
    HorizontalScrollComponent,
    OnScrollDirective,
    LicensesComponent,
    LicenseModalComponent,
    LicensesModalImportComponent,
    OrganizationFilterComponent,
    EditOrganizationModalComponent,
    UserLoggedInComponent,
    UnsubscribeComponent,
    CccDefaultCalendarComponent,
    RolesContainerComponent,
  ],
  exports: [
    FullWidthComponent,
    HeaderComponent,
    LoginAsAlertComponent,
    OrganizationRowComponent,
    OptionsHandlerComponent,
    AddOrganizationBelowComponent,
    TruncatePipe,
    StateAbbreviationPipe,
    XrefListComponent,
    XrefTableComponent,
    LoadingSpinnerComponent,
    ErrorPage,
    InputNgSearchComponent,
    DistrictRolesComponent,
    HorizontalScrollComponent,
    OnScrollDirective,
    LicensesComponent,
    LicenseModalComponent,
    LicensesModalImportComponent,
    OrganizationFilterComponent,
    EditOrganizationModalComponent,
    UserLoggedInComponent,
    UnsubscribeComponent,
    CccDefaultCalendarComponent,
    RolesContainerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgbDropdownModule,
    GenericNavigationModule,
    NgSelectModule,
    FormsModule,
    NgbAlertModule,
    NgbTooltipModule,
    ValidatedInputFieldModule,
    NgbDatepickerModule,
    FileUploadModule,
    NgbPaginationModule,
    TableModule,
    ErrorContainerModule,
    ConfirmModalModule,
    InputTextModule,
    UiSwitchModule,
    SchoolSelectorModule,
    RoleGenericTableModule,
    SchoolCalendarCommonsModule,
  ],
  providers: [
    OptionsStoreService,
    // ccc-commons SchoolYearService/OrganizationService (school calendar) inject 'apiUrl'.
    // Provided here so every module importing SharedModule points the calendar to the CCA API.
    {
      provide: 'apiUrl',
      useValue: environment.apiUrl
    },
    // Empty on purpose: ccc-commons OrganizationService falls back to 'apiUrl' (CCA API)
    // when 'orgAdminUrl' is empty, so the school calendar no longer calls organization-admin.
    {
      provide: 'orgAdminUrl',
      useValue: ''
    }
  ]
})
export class SharedModule {}
